import React from 'react'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import SideMenuNestedHeader from 'redesign/components/organisms/headers/side-menu-nested-header'
import useCmsContentViewPage from 'redesign/pages/cms-content-view/use-cms-content-view-page'
import CmsContentView from '../../cms-content-view/cms-content-view'
import { ContentWrapper } from './styles'
import type { EventDetailProps } from './types'

const EventDetail: React.FC<EventDetailProps> = ({ onClose, isDrawer, onGoBack, selectedEvent, titleKey }) => {
  const { uuid } = selectedEvent
  const { blocks, loading, content } = useCmsContentViewPage(uuid ?? '')

  if (!uuid) return null

  if (loading) return <LoadingSpinner />

  return (
    <DrawerHeaderWrapper
      providerName="events-list"
      header={
        <SideMenuNestedHeader isDrawer={Boolean(isDrawer)} onClose={onClose} titleKey={titleKey} onGoBack={onGoBack} />
      }
    >
      <ContentWrapper>
        <CmsContentView content={content} blocks={blocks} />
      </ContentWrapper>
    </DrawerHeaderWrapper>
  )
}

export default EventDetail
